export const breakpoints = {
    mq2: '768px',
    mq3: '1024px',
    mq35: '1500px',
    mq4: '1900px',
};

const minWidthQuery = (breakpoint: string) => `(min-width: ${breakpoint})`;

export const mediaQueries = {
    mq2: minWidthQuery(breakpoints.mq2),
    mq3: minWidthQuery(breakpoints.mq3),
    mq35: minWidthQuery(breakpoints.mq35),
    mq4: minWidthQuery(breakpoints.mq4),
};
